module.exports = __webpack_public_path__ + "static/media/review.d04ab3db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/review.svg
// module id = 283
// module chunks = 0